export enum SessionStatus {
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
}

export const TERMINAL_STATUSES: SessionStatus[] = [SessionStatus.Completed, SessionStatus.Failed];

export interface RoreStaffRecommendation {
  staff_id: number;
  score: number;
  factors: Record<string, number>;
  travel_time_minutes: number;
  name: string | null;
  photo_path_1: string | null;
  qualifications: string[] | null;
}

export interface RoreShiftRecommendation {
  shift_id: number;
  staff: RoreStaffRecommendation[];
}

export interface RoreSessionMetrics {
  shifts_processed: number;
  recommendations_generated: number;
  processing_time_ms: number;
}

export interface RoreSessionError {
  code: string;
  message: string;
}

export interface RoreSession {
  session_id: string;
  status: SessionStatus;
  created_at: string;
  started_at?: string;
  completed_at?: string;
  recommendations?: RoreShiftRecommendation[];
  metrics?: RoreSessionMetrics | null;
  error?: RoreSessionError;
}
